import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function addCreditCard(params) {
    const { baseUrl, requestBrand, cardType, cardNumber, cvsNumber, expiryMonth, expiryYear, ...rest } = params;

    invariant(baseUrl, 'baseUrl is a required param of addCreditCard()');
    invariant(requestBrand, 'requestBrand is a required param of addCreditCard()');
    invariant(cardType, 'cardType is a required param of addCreditCard()');
    invariant(cardNumber, 'cardNumber is a required param of addCreditCard()');
    invariant(cvsNumber, 'cvsNumber is a required param of addCreditCard()');
    invariant(expiryMonth, 'expiryMonth is a required param of addCreditCard()');
    invariant(expiryYear, 'expiryYear is a required param of addCreditCard()');

    const headers = { 'Content-Type': 'application/json', 'YNAP-REQUEST-BRAND': requestBrand };
    const url = `${baseUrl}card-details`;
    const body = JSON.stringify({ cardType, cardNumber, cvsNumber, expiryMonth, expiryYear, ...rest });

    return labelRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), 'addCreditCard');
}
